// noinspection NpmUsedModulesInstalled
import './style.scss';
import { initializeDropDownEvents } from './dropdown-functions';
import { initializeFormEvents } from './form-functions';
import { initializeSliderEvents } from './slider-functions';
import initializeCustomCalculatorFields from './calculator-fields';
import { SELECTORS } from './constants';

function attachRewardFilters({ source, $calculator, $table }) {
  const template = Handlebars.compile(source);
  const $filtersWrapper = $calculator.find(SELECTORS.FORM_WRAPPER);
  $filtersWrapper.append(template);
  const $form = $calculator.find(SELECTORS.FORM);

  initializeDropDownEvents($form);
  initializeFormEvents($form, $filtersWrapper, $calculator, $table);
  initializeSliderEvents($form);
  initializeCustomCalculatorFields($form, $table);
}

export default attachRewardFilters;
